import React from 'react';

const IoTSolutions = () => {
  return (
    <section className="section hero-wrap">
      <div className="hero-mask opacity-6 bg-dark"></div>
      <div className="hero-bg" style={{backgroundImage: "url('/images/projects/IT-IOT-A.jpg')"}}></div>
      <div className="hero-content">
        <div className="container text-center my-5">
          <div className="row">
            <div className="col-lg-9 col-xl-7 mx-auto text-center">
              <h2 className="text-11 text-white font-weight-400 mb-3">Complete IoT & Automation Solutions</h2>
              <p className="lead text-light mb-0">Rovo Automation delivers cutting-edge IoT integration and automation engineering solutions that transform businesses through smart technology and intelligent systems.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IoTSolutions;
